"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.errors = void 0;
exports.errors = {
    nestingOvercomplicated: function () { return 'Nesting of display conditions exceeds 10 levels'; },
    unhandledOperation: function (operation) { return "Unhandled operation: " + operation; }
};
